import { Preferences } from '@capacitor/preferences';

export class StateManager {
  static async updateLocation(location) {
    await Preferences.set({
      key: 'location',
      value: JSON.stringify({ location }),
    });
    await Preferences.set({
      key: 'lastLocationUpdate',
      value: new Date().toISOString(),
    });

    // Store clientModifiedAt in Preferences
    Preferences.set({
      key: 'clientModifiedAt',
      value: new Date().toISOString(),
    });
  }
}
